import { Group, ThemeIcon } from "@mantine/core";
import { IconArrowDown, IconArrowUp, IconTilde } from "@tabler/icons-react";

import { NumberText } from "../NumberText";

import type { MantineColor, MantineSize, MantineStyleProps } from "@mantine/core";
import type { FC } from "react";

export type PerformanceIndicatorProps = {
  value: number;
  suffix?: string;
  color?: MantineColor | { positive: MantineColor; negative: MantineColor; neutral?: MantineColor };
  iconBold?: boolean;
  size?: MantineSize;
  iconSize?: number;
  gap?: number | string;
} & MantineStyleProps;

export const PerformanceIndicator: FC<PerformanceIndicatorProps> = ({
  value,
  suffix = "%",
  color = { positive: "success.8", negative: "danger.7", neutral: "gray" },
  iconBold = false,
  size = "sm",
  iconSize = 14,
  gap = 0,
  ...props
}) => {
  const isPositive = value > 0;
  const isNegative = value < 0;

  const Icon = isPositive ? IconArrowUp : isNegative ? IconArrowDown : IconTilde;

  let displayColor: MantineColor;
  if (typeof color !== "object") {
    displayColor = color;
  } else {
    displayColor = isPositive
      ? color.positive
      : isNegative
        ? color.negative
        : color.neutral || "gray";
  }

  // TODO replace with bolder icon if iconBold is true
  return (
    <Group gap={gap} {...props}>
      <ThemeIcon variant="transparent" c={displayColor} size={iconSize}>
        <Icon size={iconSize} />
      </ThemeIcon>
      <NumberText
        c={displayColor}
        value={value * 100}
        suffix={suffix}
        decimalScale={2}
        fixedDecimalScale={true}
        size={size}
      />
    </Group>
  );
};
